  <button
    type="button"
    class="back-arrow-action"
    [class.back-arrow-action--header-section]="partOfHeaderSection"
    nz-button
    nzType="text"
    nzDanger
    [ngStyle]="{'top': top, 'left': left, 'right': right}"
    (click)="handleClick()"
    [attr.data-cy]="dataCy || 'back-button'"
  >
    <nz-icon nzType="arrow-left" nzTheme="outline" />
    {{ 'global.button.back' | translate }}
  </button>